<template>
  <div class="campaign-card-header-status-label" :class="classes">
    <span
      class="campaign-card-header-status-label__text"
      :class="{
        'campaign-card-header-status-label__text--note': isBeforeStart,
        'campaign-card-header-status-label__text--white': isStarted,
      }"
      >{{ statusLabelText }}</span
    >
  </div>
</template>

<script>
import { CAMPAIGN_STATUS, CAMPAIGN_STATUS_TEXT } from '@/enums';

export default {
  name: 'CampaignCardHeaderStatusLabel',
  props: {
    status: {
      type: Number,
      required: true,
    },
    remainingDays: {
      type: Number,
      required: true,
    },
  },
  computed: {
    statusLabelText() {
      if (
        [
          CAMPAIGN_STATUS.BEFORE_START,
          CAMPAIGN_STATUS.FINISHED,
          CAMPAIGN_STATUS.STOP,
        ].includes(this.status)
      ) {
        return CAMPAIGN_STATUS_TEXT[this.status];
      }

      return `残り${this.remainingDays}日`;
    },
    isBeforeStart() {
      return this.status === CAMPAIGN_STATUS.BEFORE_START;
    },
    isStarted() {
      return this.status === CAMPAIGN_STATUS.STARTED;
    },
    campaignWillEndSoon() {
      return false;
      // return this.campaign.endsSoon;
    },
    classes() {
      return {
        'campaign-card-header-status-label-highlighted': this
          .campaignWillEndSoon,
        'campaign-card-header-status-label-black':
          !this.campaignWillEndSoon && this.isStarted,
        'campaign-card-header-status-label-white':
          this.status === CAMPAIGN_STATUS.BEFORE_START,
        'campaign-card-header-status-label-gray':
          this.status === CAMPAIGN_STATUS.FINISHED ||
          this.status === CAMPAIGN_STATUS.STOP,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.campaign-card-header-status-label {
  width: 80px;
  height: 26px;

  display: flex;
  justify-content: center;
  align-items: center;

  &-highlighted {
    background: #9a6cbf;
  }

  &-white {
    background: $c-white-base;
  }

  &-gray {
    background: map-get($c-black, 20);
  }

  &-black {
    background: map-get($c-black, 80);
  }
}

.campaign-card-header-status-label__text {
  font-size: 12px;
  line-height: 18px;
}

.campaign-card-header-status-label__text--note {
  color: $c-black-note;
}

.campaign-card-header-status-label__text--white {
  color: $c-white-base;
}
</style>
